import { SIGNUP_NEW } from 'actions/Types';

export default (state = null, action) => {
  if (action.type === `${SIGNUP_NEW}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${SIGNUP_NEW}_FAILURE`) {
    return null;
  }

  return state;
};
